import React, { useEffect, useState } from 'react';

import axios from 'axios';
import _ from 'lodash';
import mapboxgl from 'mapbox-gl';
import './MapboxComponent.css';
import { connect } from 'react-redux';

import * as actionTypes from '../../store/actions/index';
import './BaseMap.css';
import { getCurrentLocationCoordinates } from '../../utils/utils';

const BaseMap = (props) => {
  mapboxgl.accessToken = `${process.env.REACT_APP_MAPBOX_KEY}`.trimEnd();

  const { optionData, clientCurrentLocation } = props;
  const [map, setMap] = useState();

  //forming object for mapbox

  useEffect(() => {
    if (optionData) {
      let i = 0;
      let locationObj = [];

      if (optionData) {
        const finalArr = [];
        const j = 0;

        optionData.forEach((entry) => {
          if (
            finalArr.length > 0 &&
            entry.address &&
            entry.address != null &&
            typeof entry.address === 'object' &&
            Object.keys(entry.address)?.length > 0
          ) {
            const found = finalArr.some((el) => {
              return el.address && el.address.address === entry.address.address;
            });

            if (found) {
              entry.address.lat = entry?.address?.lat + 0.00002;
              entry.address.lng = entry?.address?.lng + 0.00002;
            }
            const found1 = finalArr.some(
              (el) => el.address && el.address.lat === entry?.address?.lat,
            );

            if (found1) {
              entry.address.lat = entry?.address?.lat + 0.00003;
              entry.address.lng = entry?.address?.lng + 0.00003;
            }
            finalArr.push(entry);
          } else {
            finalArr.push(entry);
          }
        });

        locationObj = _.map(finalArr, (o) => {
          i++;
          const data = o;
          let optionsObj = {};

          if (typeof data.address === 'object' && data.address !== null) {
            const address = data.address.address;
            const d = data.address?.lng + ',' + data.address?.lat;
            const unit =
              data &&
              data.availableSpaces &&
              data.availableSpaces.length > 0 &&
              data.availableSpaces[0] != null &&
              data.availableSpaces[0].unit;

            // let unit = data && data.availableSpaces && data.availableSpaces[0].unit
            optionsObj = {
              type: 'Feature',
              properties: {
                id: i,
                address: address,
                description: data.optionName,
                unit: unit ? unit : '',
              },
              geometry: {
                type: 'Point',
                coordinates: JSON.parse('[' + d + ']'),
              },
            };
          } else {
            optionsObj = {};
          }

          return optionsObj;
        });
      }

      const map = new mapboxgl.Map({
        container: 'mapContainer',
        style: process.env.REACT_APP_MAPBOX_STYLE.trim(),
      });

      map.addControl(new mapboxgl.FullscreenControl());

      const nav = new mapboxgl.NavigationControl({ showCompass: false });

      map.addControl(nav, 'bottom-right');

      const selectedOptionId = null;
      const source = {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: locationObj,
        },
      };

      let popup;

      map.on('load', async function () {
        addSource();
        addMarkers();

        const currentLocation = clientCurrentLocation;

        if (currentLocation) {
          const currentLocationCoordinates = await getCurrentLocationCoordinates(currentLocation);

          if (currentLocationCoordinates.data.results.length > 0) {
            const currentCoordnates = [
              currentLocationCoordinates.data.results[0].geometry.location.lng,
              currentLocationCoordinates.data.results[0].geometry.location.lat,
            ];

            props.setLatLong(currentCoordnates);

            const el = document.createElement('div');

            /* Assign the `marker` class to each marker for styling. */
            el.className = 'marker';
            el.style.background = '#003F2D';

            new mapboxgl.Marker(el).setLngLat(currentCoordnates).addTo(map);
          }
        } else {
          props.setLatLong([]);
        }

        const layerList = document.getElementById('menu');
        const inputs = layerList?.getElementsByTagName('button');

        function switchLayer(layer) {
          const element = layer.target;
          const layerId = layer.target.id;

          if (layerId === 'satellite-v9') {
            element.classList.add('activeMapBtn');
            const btn = document.getElementById('light-v10');

            btn.classList.remove('activeMapBtn');
          }
          if (layerId === 'light-v10') {
            element.classList.add('activeMapBtn');
            const btn = document.getElementById('satellite-v9');

            btn.classList.remove('activeMapBtn');
          }
          map.setStyle('mapbox://styles/mapbox/' + layerId);
          map.on('style.load', function () {
            if (!map.getSource('places')) {
              addSource();
            }
          });
        }

        for (let i = 0; i < inputs?.length; i++) {
          //console.log(inputs[i]);
          inputs[i].onclick = switchLayer;
        }

        function addSource() {
          map.addSource('places', source);
        }

        function createPopUp(currentFeature, className) {
          const popUps = document.getElementsByClassName('option-popup');

          if (popUps[0]) popUps[0].remove();
          if (currentFeature.properties.unit) {
            new mapboxgl.Popup({
              closeOnClick: false,
              closeButton: false,
              className: 'option-popup',
            })
              .setLngLat(currentFeature.geometry.coordinates)
              .setHTML(
                currentFeature.properties.description +
                  '<br/> unit ' +
                  currentFeature.properties.unit,
              )
              .addTo(map);
          } else {
            new mapboxgl.Popup({
              closeOnClick: false,
              closeButton: false,
              className: 'option-popup',
            })
              .setLngLat(currentFeature.geometry.coordinates)
              .setHTML(currentFeature.properties.description)
              .addTo(map);
          }
        }

        function addMarkers() {
          /* For each feature in the GeoJSON object above: */
          source.data.features.forEach(function (marker, i) {
            /* Create a div element for the marker. */
            const el = document.createElement('div');
            /* Assign a unique `id` to the marker. */
            const id = marker && marker.properties && marker.properties.id;

            el.id = 'marker-' + id;
            /* Assign the `marker` class to each marker for styling. */
            el.className = 'marker';
            el.innerHTML = '<span><b>' + (i + 1) + '</b></span>';
            const coords = marker && marker.geometry && marker.geometry.coordinates;

            const coordinates = coords && coords.slice();

            if (coordinates) {
              new mapboxgl.Marker(el).setLngLat(coordinates).addTo(map);
            }

            el.addEventListener('mouseover', function (e) {
              /* Fly to the point */
              /* Close all other popups and display popup for clicked store */
              createPopUp(marker, 'option-popup');
              /* Highlight listing in sidebar */
              const activeItem = document.getElementsByClassName('active');

              e.stopPropagation();
              if (activeItem[0]) {
                activeItem[0].classList.remove('active');
              }
            });
            el.addEventListener('mouseout', function () {
              map.getCanvas().style.cursor = '';
              const popUps = document.getElementsByClassName('option-popup');

              if (popUps[0]) popUps[0].remove();
            });
          });
        }

        map.getCanvas().style.cursor = 'pointer';

        if (
          source &&
          source.data &&
          source.data.features &&
          source.data.features.length > 0 &&
          source.data.features[0].geometry
        ) {
          map.flyTo({
            center: source.data.features[0].geometry.coordinates,
            zoom: 13,
            speed: 3,
          });
        }
      });

      map.resize();
      setMap(map);
      props.setMap(map);
    }
    // eslint-disable-next-line
  }, [optionData, clientCurrentLocation]);

  return (
    <div>
      <div id="menu">
        <button id="light-v10" className="activeMapBtn">
          Map
        </button>
        <button id="satellite-v9">Satellite</button>
      </div>
      <div id="mapContainer" className="map"></div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    locations: state.locRed.locations,
    clientCurrentLocation: state.comRed.displayCurrentLocation,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedOptions: (selectedOptions) => dispatch(actionTypes.locationAction(selectedOptions)),
    setLatLong: (latLng) => dispatch({ type: 'SET_LAT_LONG_CURRENT_LOCATION', latLng }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BaseMap);
